export enum EDetailPageRightMenuGeneralInfoType {
  T1,
  T2,
  T3,
  T4,
  Transmittal,
}
